import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { LocaleSwitcherComponent } from "../locale-switcher/locale-switcher.component";
import { ThemeSwitcherComponent } from "../theme-switcher/theme-switcher.component";
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GraphapiService } from '../../services/graphapi.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../environments/environment'

import * as FileSaver from 'file-saver';
import { AuthGuardService } from '../../guard/auth-guard/auth-guard.service';
import { UnauthorizedComponent } from '../unauthorized/unauthorized.component';
import { UtilService } from '../../services/util.service';
import { TourService } from '../../services/tour.service';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [LocaleSwitcherComponent, MatCardModule, ThemeSwitcherComponent, MatIconModule, RouterModule, CommonModule,
    MatExpansionModule, MatButtonModule, MatMenuModule, MatTooltipModule, TranslateModule, UnauthorizedComponent],
  // providers: [EnvironmentConfiguration,{ provide: Environments, useValue: environments }]
})
export class HeaderComponent implements OnInit {
  role: any;
  // `title`, `userName`, `workId`, and `appName` are getters (not fields set once at
  // construction) so they re-read localStorage on every change-detection cycle. Previously
  // these were plain fields initialized from localStorage at field-declaration time - since
  // that runs before app.component.ts's login flow finishes populating
  // username/lastname/emailId/AppName in localStorage, the header would render "null null"
  // and a blank title on first load, only becoming correct after a manual reload (once
  // localStorage was already populated before HeaderComponent got constructed again). As
  // getters, they automatically reflect the real values as soon as auth resolves and
  // localStorage is populated, with no explicit reactive plumbing needed.
  get title(): string {
    return localStorage.getItem('AppName') ?? '';
  }
  get userName(): string {
    const first = localStorage.getItem('username') ?? '';
    const last = localStorage.getItem('lastname') ?? '';
    return `${first} ${last}`.trim();
  }
  get workId(): string | null {
    return localStorage.getItem('emailId');
  }
  get appName(): string | null {
    return localStorage.getItem('appName');
  }
  Company: any = ''
  toyotaLightLogoLink = "../../../../assets/images/Brand logo/VIS_toyota_logo_horiz_black_RGB_2021.svg";
  toyotaDarkLogoLink = "../../../../assets/images/Brand logo/VIS_toyota_logo_horiz_white_RGB_2021.svg";

  panelOpenState = signal(true);
  refPanelOpenState = signal(false);
  isPanelClosed: boolean = true;
  isRefPanelOpen: boolean = false;
  accessKey: any;
  secretKey: any;
  sessionToken: any;
  refereceDocsList: any = [];
  notificationsList: any = [];
  affiliate: any = '';
  id_token: any;
  access_token: any;
  refresh_token: any;
  graphapproverID: any;
  approverName: any;
  managerId: any;
  errormsg: any;
  Useremail: any;
  checkAffiliate: any = [];
  countermeasure_enabled :boolean = true;
  @ViewChild('navbarNav') navbarNav: ElementRef | undefined;
  getUserDetails: any;
  counterMeasureAvailable: boolean = false;
  // Routes that have a guided tour. Add a route here when its tour is built
  // (e.g. '/approvals', '/reports', '/admin', '/countermeasure').
  private readonly tourEnabledRoutes: string[] = ['/home'];
  // True when the current route has a tour; controls the tour button visibility.
  showTourButton: boolean = false;
  // Guard so a repeated InvalidAuthenticationToken (e.g. refresh token itself is bad) retries
  // getmanagergraphApi()/getProfilePhotoo() in-place only once instead of looping forever -
  // previously a full window.location.reload() was used here, which caused the app to go
  // through 2-3 flickering reloads right after a fresh login.
  private managerApiRetried = false;
  private profilePhotoRetried = false;
  constructor(public authSrv: AuthGuardService, public graphapiservice: GraphapiService,
    public sanitizer: DomSanitizer, public _service: CommonService,
    public spinner: NgxSpinnerService, public router: Router, public translate: TranslateService, private _utilService: UtilService,
    private tourService: TourService, private readonly authService: AuthService
  ) {
    this.Useremail = localStorage.getItem('emailId');
    // Header renders outside the router-outlet/guard, so it constructs even when this tab has
    // no usable session (e.g. a new tab/fresh browser launch with no refresh token yet) -
    // skip firing authenticated calls with a null token; a real session reload re-runs this.
    if (this.authSrv.getAccessToken()) {
      this.getProfilePhotoo();
      this.onGetRole();
    }

    // On a fresh (first-ever) login, this component is constructed BEFORE
    // app.component.ts's login flow finishes writing AOV_IDTOKEN/Affiliate/roles/token to
    // localStorage, so the onGetRole()/getProfilePhotoo() calls above are no-ops (or, for
    // getProfilePhotoo(), were skipped above). Re-run both once that flow signals
    // completion, so the affiliate/role/menu/photo data appears without needing a full
    // page reload.
    this._service.authReady$.subscribe(() => {
      this.Useremail = localStorage.getItem('emailId');
      this.getProfilePhotoo();
      this.onGetRole();
    });
  }

  collapseNavbar() {
    const navbar = this.navbarNav?.nativeElement;
    if (navbar.classList.contains('show')) {
      navbar.classList.remove('show');
    }
  }

  //to get login user details
  async onGetRole() {//NOSONAR
    if (sessionStorage.getItem('AOV_IDTOKEN') !== null && localStorage.getItem('Affiliate') !== null) {
      const currentUserRole = JSON.parse(sessionStorage.getItem('AOV_IDTOKEN')!);
      await this.getaffilate(currentUserRole);

    }
  }
  //to get login user affiliate details
  getaffilate(currentUserRole: any) {
    // REQUIRED claim guard - `roles` drives every affiliate/authorization decision below
    // (and in userRoleCheck(), which this method calls for HR-enabled affiliates). Both
    // used to call `.map`/`.filter` directly on `currentUserRole['roles']` with no guard,
    // so a token missing that claim threw an uncaught TypeError deep inside this subscribe
    // callback - silently aborting the whole role/menu/affiliate resolution with no visible
    // error, instead of failing cleanly. Guard once, here, before either path can run.
    if (!Array.isArray(currentUserRole?.roles) || currentUserRole.roles.length === 0) {
      console.error('[HeaderComponent] Login token is missing the required "roles" claim - treating as Unauthorized.');
      this.authSrv.setRole('Unauthorized');
      this.role = this.authSrv.getRole();
      this.router.navigateByUrl('/unauthorized');
      return;
    }
    this._service.getAffiliatesList().subscribe((res: any) => {
      if (res.payload[0] !== null) {
        let affilateList = res.payload;
        affilateList = affilateList.find((item: any) => item.affiliate_code == ((localStorage.getItem('Affiliate') !== undefined) && (localStorage.getItem('Affiliate') !== null) ? localStorage.getItem('Affiliate') : this.authService.resolveAffiliateCode(currentUserRole.roles)));
        localStorage.setItem("AppName", affilateList.app_name);
        localStorage.setItem("hrsystem", affilateList.hr_system_enabled);
        localStorage.setItem('setFormatDate', affilateList.date_format ? affilateList.date_format:'MM/DD/YYYY')
        this._service.setdefaultdate(affilateList.date_format ? affilateList.date_format:'MM/DD/YYYY')
        // `title` is now a getter that reads localStorage('AppName') directly - the
        // setItem above is enough for it to reflect the new value on the next
        // change-detection cycle, no manual reassignment needed (and none is possible,
        // since a getter-only property can't be assigned to).
        this.countermeasure_enabled = affilateList?.countermeasure_enabled;    
        if (affilateList.hr_system_enabled) {
          this.userRoleCheck(currentUserRole);
        } else {
          const rolescheck: string[] = currentUserRole['roles'];
          this._service.setStoredRoles(rolescheck);
          // Real array of uppercased roles (not a comma-separated string coerced from the
          // array) so membership checks below use exact array `.includes(...)` instead of
          // fragile substring matching against a joined string.
          const roles: string[] = rolescheck.map((r: string) => r.toUpperCase());
          const companyAffliate: any = this.authService.mapAffiliate(currentUserRole['Company Name']);
          this.authSrv.setCompanyAfl(companyAffliate);
          this.checkAffiliate = this.authService.computeAffiliateRoles(rolescheck);
          this.authSrv.setAffliate(this.checkAffiliate);
          this.Company = this.authSrv.getCompanyAfl();
          this._service.setlangugae(localStorage.getItem('langCode'));
          if (localStorage.getItem('langCode') != localStorage.getItem("defaultlang")) {
            this._service.setdefaultlang('Y');
          } else {
            this._service.setdefaultlang('N');
          }
          if (roles.length > 0) {//NOSONAR
            this.affiliate = localStorage.getItem('Affiliate');
            const tier = this.authService.classifyRoleTier(rolescheck, this.affiliate);
            if (tier === 'Admin') {
              this.authSrv.setRole('Admin');
              this.counterMeasureAvailable = true;
              this.role = this.authSrv.getRole();
              this.usercheckval();
            } else if (tier === 'ApproverAdmin') {
              this.authSrv.setRole('ApproverAdmin');
              this.counterMeasureAvailable = true;
              this.role = this.authSrv.getRole();
              this.usercheckval();
            }
            else {
              const body = {
                "email": localStorage.getItem('emailId'),
                "affilitae": localStorage.getItem('Affiliate')
              }
              // Uses the shared, reference-counted CommonService.beginLoading()/endLoading()
              // instead of NgxSpinnerService.show()/hide() directly - this role-resolution call
              // runs concurrently with HomeComponent's own counted initial-page-load spinner
              // (both start right after a fresh login), so a direct hide() here used to turn
              // off the shared overlay the moment THIS call finished, even while Home's own
              // category/disclosure data was still loading - the classic "loader goes off, then
              // comes back" flicker.
              this._service.beginLoading();
              this._service.checkApproverId(body.email, body.affilitae).subscribe((res: any) => {
                this._service.endLoading();
                this.authSrv.setRole(this.authService.resolveApproverTier(res.payload));
                this.role = this.authSrv.getRole();
                this.usercheckval();

                if (res?.payload[1] !== null && res?.payload[1]?.is_countermeasure == true) {
                  this.counterMeasureAvailable = true;
                }else{
                  this.counterMeasureAvailable = false;
                }

              }, (_err: any) => {
                this.authSrv.setRole('User');
                this._service.endLoading();
                this.usercheckval();
              });
            }
            this.routevalcheck();
            this._service.triggerHomeFn(true);
            this._service.isFormReset.subscribe((data: any) => {
              if (data) {
                this.reference();
              }
            })
            this.getmanagergraphApi();
          }
        }
      }
    }, err => {
      localStorage.setItem("langCode", 'en')
      localStorage.setItem("defaultlang", 'en')
    })
  }


  // to check roles for subAffiliate feature
  userRoleCheck(currentUserRole: any) {
    const employeeId = this.authService.getEmployeeIdFromIdToken();
    const email = this.authService.getWorkEmailFromIdToken();
    if (!employeeId && !email) {
      this.markUnauthorizedRole();
      return;
    }

    let data = currentUserRole['roles'];
    this.affiliate = localStorage.getItem('Affiliate');
    //let valueToRemove = `${this.affiliate}-User`;
    let val = data.filter((item: any) => !item.includes('-User'));
    this._service.checkUserInHR(employeeId ? undefined : email, undefined, employeeId || undefined).subscribe((res: any) => {
      const matchedRows = Array.isArray(res?.payload) ? res.payload.filter((item: any) =>
        employeeId
          ? String(item?.employee_id ?? '').trim() === employeeId
          : typeof item?.work_email === 'string' && item.work_email.trim().toLowerCase() === email
      ) : [];
      if (matchedRows.length === 0) {
        this.markUnauthorizedRole();
        return;
      }
      res.payload = matchedRows;
      if (res.payload[0] !== null) {
        res.payload.map((item: any) => val.push(item.affiliate_id + '-User'));
        this.getUserDetails = res.payload.filter((item: any) => item.affiliate_id == this.affiliate);
        let s = new Set(val);
        let rolescheck: string[] = [...s] as string[]
        this._service.setStoredRoles(rolescheck)
        localStorage.setItem('GAC', JSON.stringify(res.payload));
        let usercheck = val.filter((item: any) => (item.includes('User')));
        let b = new Set(usercheck);
        let userrolescheck: any = [...b]
        const roles: string[] = rolescheck.map((r: string) => r.toUpperCase());
        if ((roles.includes(`${this.affiliate}-ADMIN`) || roles.includes(`${this.affiliate}-USER`) || roles.includes(`${this.affiliate}-OVERSIGHT`))) {
          this._service.setaffiliate(this.affiliate);
          localStorage.setItem('Affiliate', this.affiliate);
        } else if (userrolescheck[0].split('-')[0]) {
          this._service.setaffiliate(userrolescheck[0].split('-')[0]);
          localStorage.setItem('Affiliate', userrolescheck[0].split('-')[0]);
        } else {
          this._service.setaffiliate(this.affiliate)
          localStorage.setItem('Affiliate', this.affiliate);
        }
        const companyAffliate: any = this.authService.mapAffiliate(currentUserRole['Company Name']);
        this.authSrv.setCompanyAfl(companyAffliate);
        this.checkAffiliate = this.authService.computeAffiliateRoles(rolescheck);
        this.authSrv.setAffliate(this.checkAffiliate);
        this.Company = this.authSrv.getCompanyAfl();
        this._service.setlangugae(localStorage.getItem('langCode'));
        if (localStorage.getItem('langCode') != localStorage.getItem("defaultlang")) {
          this._service.setdefaultlang('Y');
        } else {
          this._service.setdefaultlang('N');
        }
        if (roles.length > 0) {//NOSONAR
          this.affiliate = localStorage.getItem('Affiliate');
          const tier = this.authService.classifyRoleTier(rolescheck, this.affiliate);
          if (tier === 'Admin') {
            this.authSrv.setRole('Admin');
            this.role = this.authSrv.getRole();
            this.counterMeasureAvailable = true;
            this.usercheckval();
          } else if (tier === 'ApproverAdmin') {
            this.authSrv.setRole('ApproverAdmin');
            this.counterMeasureAvailable = true;
            this.role = this.authSrv.getRole();
            this.usercheckval();
          }
          else {
            const body = {
              "email": localStorage.getItem('emailId'),
              "affilitae": localStorage.getItem('Affiliate')
            }
            // See the identical comment in getaffilate()'s non-HR branch - shared counter
            // instead of a direct show()/hide() so this doesn't prematurely hide the overlay
            // while Home's own initial-load fetch is still in flight.
            this._service.beginLoading();
            this._service.checkApproverId(body.email, body.affilitae).subscribe((res: any) => {
              this._service.endLoading();
              this.authSrv.setRole(this.authService.resolveApproverTier(res.payload));
              this.role = this.authSrv.getRole();
              this.usercheckval();

              if (res?.payload[1] !== null && res?.payload[1]?.is_countermeasure == true) {
                this.counterMeasureAvailable = true;
              } else {
                this.counterMeasureAvailable = false;
              }

            }, (_err: any) => {
              this.authSrv.setRole('User');
              this._service.endLoading();
              this.usercheckval();
            });
          }
          this.routevalcheck();
          this._service.triggerHomeFn(true);
          this._service.isFormReset.subscribe((data: any) => {
            if (data) {
              this.reference();
            }
          })
          this.getmanagergraphApi();
        }
      } else {
        const rolescheck: string[] = val;
        this._service.setStoredRoles(rolescheck);
        const roles: string[] = rolescheck.map((r: string) => r.toUpperCase());

        const companyAffliate: any = this.authService.mapAffiliate(currentUserRole['Company Name']);
        this.authSrv.setCompanyAfl(companyAffliate);
        this.checkAffiliate = this.authService.computeAffiliateRoles(rolescheck);
        this.authSrv.setAffliate(this.checkAffiliate);
        this.Company = this.authSrv.getCompanyAfl();
        this._service.setlangugae(localStorage.getItem('langCode'));
        if (localStorage.getItem('langCode') != localStorage.getItem("defaultlang")) {
          this._service.setdefaultlang('Y');
        } else {
          this._service.setdefaultlang('N');
        }
        if (roles.length > 0) {//NOSONAR
          this.affiliate = localStorage.getItem('Affiliate');
          const tier = this.authService.classifyRoleTier(rolescheck, this.affiliate);
          if (tier === 'Admin') {
            this.authSrv.setRole('Admin');
            this.counterMeasureAvailable = true;
            this.role = this.authSrv.getRole();
            this.usercheckval();
          } else if (tier === 'ApproverAdmin') {
            this.authSrv.setRole('ApproverAdmin');
            this.counterMeasureAvailable = true;
            this.role = this.authSrv.getRole();
            this.usercheckval();
          }
          else if (tier === 'User') {
            const body = {
              "email": localStorage.getItem('emailId'),
              "affilitae": localStorage.getItem('Affiliate')
            }
            // See the identical comment in getaffilate()'s non-HR branch - shared counter
            // instead of a direct show()/hide() so this doesn't prematurely hide the overlay
            // while Home's own initial-load fetch is still in flight.
            this._service.beginLoading();
            this._service.checkApproverId(body.email, body.affilitae).subscribe((res: any) => {
              this._service.endLoading();
              this.authSrv.setRole(this.authService.resolveApproverTier(res.payload));
              this.role = this.authSrv.getRole();
              this.usercheckval();

              if (res?.payload[1] !== null && res?.payload[1]?.is_countermeasure == true) {
                this.counterMeasureAvailable = true;
              } else {
                this.counterMeasureAvailable = false;
              }

            }, (_err: any) => {
              this.authSrv.setRole('User');
              this._service.endLoading();
              this.usercheckval();
            });
          } else {
            this.authSrv.setRole('Unauthorized');
            this.role = this.authSrv.getRole()
            this.router.navigateByUrl('/unauthorized')
          }
          this.routevalcheck();
          this._service.triggerHomeFn(true);
          this._service.isFormReset.subscribe((data: any) => {
            if (data) {
              this.reference();
            }
          })
          this.getmanagergraphApi();
        }
      }
    }, (_err: any) => this.markUnauthorizedRole());
  }

  private markUnauthorizedRole(): void {
    this.authSrv.setRole('Unauthorized');
    this.role = this.authSrv.getRole();
    this.router.navigateByUrl('/unauthorized');
  }

  //to restrict user without admin/approver access from accesing admin /approver screens
  routevalcheck() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const role = this.authSrv.getRole();
        const url = event.url;
        if (role === 'Approver' && url === '/admin') {
          this.router.navigate(['/approvals']);
        }
        else if (role === 'Admin' && url === '/home') {//NOSONAR
          this.router.navigate(['/home']);
        }
        else if ((role === 'ApproverAdmin') && (url === '/home')) {
          this.router.navigate(['/home']);
        }
        else if ((role === 'User' && url === '/admin') || (role === 'User' && url === '/approvals')) {
          this.router.navigate(['/home']);
        }
      }
    })
  }

  //get user's manager details
  async getmanagergraphApi() {
    if (localStorage.getItem('hrsystem') !== 'false') {
      return;
    }
    (await this.graphapiservice.getManagerDatails()).subscribe((response: any) => {
      this.graphapproverID = response.mail;
      this._service.setmanagerMailid(this.graphapproverID)
      this.approverName = response.displayName.split('(')[0];
      this._service.setapproverName(this.approverName)
      this.managerId = response.displayName.split('(')[0];
      const newManagerID = response.mail;
      this._service.setnewManagerMailid(newManagerID);
      this._service.setmanagerId(this.managerId.trim())
    }, async (_err: any) => {
      // No spinner.hide() here - this method never calls spinner.show()/beginLoading()
      // itself (it's a background manager-details fetch), so hiding here would only ever
      // risk prematurely closing the shared, reference-counted overlay that Home/
      // DisclosureTable/the role-resolution flow above are relying on during the initial
      // page load, without this method ever having contributed to showing it.
      if (_err.error.error.code === 'InvalidAuthenticationToken') {
        if (this.managerApiRetried) {
          this.errormsg = "Timed out.Please relogin again";
          window.scrollTo(0, 0);
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = environment.redirectURI;
          }, 2000)
          return;
        }
        this.managerApiRetried = true;
        const data: any = {
          'grant_type': "refresh_token",
          'client_id': environment.clientId,
          'refresh_token': this.authSrv.getRefreshToken()
        };
        const refreshBody = [];
        for (const property in data) {
          const encodedKey = encodeURIComponent(property);
          const encodedValue = encodeURIComponent(data[property]);
          refreshBody.push(encodedKey + "=" + encodedValue);
        }
        const body = refreshBody.join("&");
        await this._service.getTokens(body).then((res: any) => {
          if (res != null) {
            this.id_token = res.id_token
            this.access_token = res.access_token
            this.refresh_token = res.refresh_token
            this.authSrv.setTokens({
              idToken: this.id_token,
              accessToken: this.access_token,
              refreshToken: this.refresh_token,
              newIdTokenKey: this.id_token
            });
            // Retry in-place now that the token has been refreshed, instead of a full
            // page reload (which caused extra flicker loads right after login).
            this.getmanagergraphApi();
          }
        }, err => {
          this.errormsg = "Timed out.Please relogin again";
          window.scrollTo(0, 0);
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            this.authSrv.clearTokens();
            window.location.href = environment.redirectURI;
          }, 2000)
        })
      }else if (_err.error.error.code === 'Authorization_RequestDenied') {
        this.errormsg = 'Insufficient privileges available for the user. Please contact your administrator.';
        this._utilService.openSnackBar('Insufficient privileges available for the user. Please contact your administrator.');
      } 
      else {
        this.errormsg = "MANAGER_FETCH_ERROR_MSG";
        this.translate.get('managerDetailsError').subscribe((translatedMessage: string) => {
          this._utilService.openSnackBar(translatedMessage);
        });
        window.scrollTo(0, 0);
      }
    })
  }

  ngOnInit() {
    this.role = this.authSrv.getRole();
    this.showTourButton = this.isTourEnabledRoute(this.router.url);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showTourButton = this.isTourEnabledRoute(event.urlAfterRedirects);
      }
    });
    this._service.triggerCountermeasure$.subscribe((res: any) => {
      if (res) {
        if (sessionStorage.getItem('AOV_IDTOKEN') !== null && localStorage.getItem('Affiliate') !== null) {
          const currentUserRole = JSON.parse(sessionStorage.getItem('AOV_IDTOKEN')!);
          this.getaffilate(currentUserRole);
        }
      }
    });
  }

  //to stop Propagation for mat-expansion-panel
  handle(event: Event) {
    event.stopPropagation();
    this.isPanelClosed = !this.isPanelClosed;
    this.panelOpenState.set(false);
  }
  handleRef(event: Event) {
    this.isRefPanelOpen = !this.isRefPanelOpen;
    event.stopPropagation();
    this.refPanelOpenState.set(this.isRefPanelOpen);
  }

  //to sign out btn
  logout() {
    localStorage.clear();
    // Marks this as an INTENTIONAL, user-clicked sign-out (as opposed to an idle timeout
    // or a technical auth failure elsewhere clearing storage) - AppComponent's cross-tab
    // `storage` listener checks for this key to decide whether other open tabs should be
    // signed out instantly (this case) or shown the "session ended, click to re-login"
    // dialog (every other case). Set AFTER clear() so it isn't immediately wiped by it.
    localStorage.setItem('manualSignOut', String(Date.now()));
    sessionStorage.clear();
    this.authSrv.clearTokens();
    window.location.href = environment.logoutUrl;
  }

  //get user profile picture
  async getProfilePhotoo() {

    (await this.graphapiservice.getProfilePhotoFn()).subscribe((response: any) => {
      const urlCreator = window.URL;
      const pictureResponse = this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(response));//NOSONAR
      this.graphapiservice.setProfilePhoto(pictureResponse);
      this.graphapiservice.setImageNotFound(false);
    }, async (_err: any) => {
      // No spinner.hide() here either, same reason as getmanagergraphApi() above - this
      // method never shows its own spinner, so it must not touch the shared overlay.
      if (_err?.error?.error?.code === 'InvalidAuthenticationToken') {
        if (this.profilePhotoRetried) {
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = environment.logoutUrl;
          }, 2000)
          return;
        }
        this.profilePhotoRetried = true;
        const data: any = {
          'grant_type': "refresh_token",
          'client_id': environment.clientId,
          'refresh_token': this.authSrv.getRefreshToken()
        };
        const refreshBody = [];
        for (const property in data) {
          const encodedKey = encodeURIComponent(property);
          const encodedValue = encodeURIComponent(data[property]);
          refreshBody.push(encodedKey + "=" + encodedValue);
        }
        const body = refreshBody.join("&");
        await this._service.getTokens(body).then((res: any) => {
          if (res != null) {
            this.id_token = res.id_token
            this.access_token = res.access_token
            this.refresh_token = res.refresh_token
            this.authSrv.setTokens({
              idToken: this.id_token,
              accessToken: this.access_token,
              refreshToken: this.refresh_token,
              newIdTokenKey: this.id_token
            });
            // Retry in-place now that the token has been refreshed, instead of a full
            // page reload (which caused extra flicker loads right after login).
            this.getProfilePhotoo();
          }
        }, err => {
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            this.authSrv.clearTokens();
            this.spinner.hide()
            window.location.href = environment.logoutUrl;
          }, 2000)
        })
      } else {
        this.graphapiservice.setImageNotFound(true);
      }
    })
  }

  //get referece Docs List
  reference() {
    let hrEnable = localStorage.getItem('hrsystem')
    this._service.getReferenceDocument(this.affiliate, 'Home').subscribe((res: any) => {
      this.refereceDocsList=[];
      let tempRefereceDocsList: any[] = [];
      if (res.payload[0] != null) {
        tempRefereceDocsList = res.payload;
        tempRefereceDocsList.sort((a: any, b: any) => a.order_no - b.order_no);
        tempRefereceDocsList.forEach((item: any) => {
          if (item.is_link !='file') {
            item.file_path = decodeURIComponent(item.file_path);
          }
        })
        if (hrEnable == "true") {
          this.refereceDocsList = tempRefereceDocsList.filter((resp: any) => {
            if (resp.target_value && resp.condition_field) {
              return this.getUserDetails[0][resp.condition_field] === resp.target_value;
            }
            return true;
          });
        } else {
          this.refereceDocsList = tempRefereceDocsList;
        }
      } else {
      }
    }, err => {
    })
  }

  //to download attachments
  async download(file: any) {
    this.spinner.show()
    const body = {
      docType: 'reference',
      referenceId: file.document_id,
      affiliate: this.affiliate
    }
    this._service.getPresignedUrl(body).subscribe((res: any) => {
      const data: any = JSON.parse(res.body);
      const url = data.SignedURL
      // Use display_file_name for clean filename without extra numbers
      const fileName = data.file_name_org;
      
      // Fetch the file as blob to use custom filename
      fetch(url).then(response => response.blob()).then(blob => {
        FileSaver.saveAs(blob, fileName);
        this.spinner.hide()
      }).catch(err => {
        this.spinner.hide()
      })
    }, err => {
      this.spinner.hide()
    })
  }
  onAwayFromApprovals() {
    localStorage.removeItem('filtersts');
    localStorage.removeItem('approvalTab')
    localStorage.removeItem('historicStatus');
  }


  usercheckval(){
    const role = this.authSrv.getRole();
    const url = window.location.href.split('#')[1] || '';
    // Match the section root AND any of its nested routes (e.g. bookmarked
    // /approvals/view-questions/:category/:affiliate/:id), not just an exact path.
    const isAdminRoute = url === '/admin' || url.startsWith('/admin/');
    const isApprovalsRoute = url === '/approvals' || url.startsWith('/approvals/');
    if (role === 'Approver' && isAdminRoute) {//NOSONAR
      this.router.navigate(['/home']);
    }
    else if (role === 'Admin' && url === '/home') {//NOSONAR
      this.router.navigate(['/home']);
    }
    else if ((role === 'User' && isAdminRoute) || (role === 'User' && isApprovalsRoute)) {
      this.router.navigate(['/home']);
    }
    else if ((role === 'ApproverAdmin') && isAdminRoute) {
      this.router.navigate(['/home']);
    }
    else if ((role === 'ApproverAdmin') && ( url === '/home')) {
      this.router.navigate(['/home']);
    }
    else if (( role === 'Unauthorized') && ( isAdminRoute || isApprovalsRoute || url === '/home' || url === '/')) {
      this.router.navigate(['/unauthorized']);
    }
  }

  // /**
  //  * Start the main application tour
  //  */
  // startMainTour(): void {
  //   this.tourService.startMainTour();
  // }

  /**
   * Launch the combined Dashboard -> Home (view questions) tour.
   * Fetches the available categories and navigates to the FIRST category's
   * NEW disclosure form (not a submitted disclosure) for the cross-page
   * walk-through. If no category is available, it falls back to showing just
   * the dashboard steps.
   */
  private startHomeCombinedTour(): void {
    const affiliate = localStorage.getItem('Affiliate') || this.affiliate;

    this._service.getCategoryForUser('N').subscribe((res: any) => {
      const firstCategory = res?.payload?.find(
        (item: any) => item?.sub_category && item?.category_id
      );

      if (firstCategory) {
        // A NEW disclosure form route uses the category name (sub_category) and
        // the category_id -> renders the blank questionnaire form, not a submitted one.
        this.tourService.startCombinedDashboardHomeTourCrossPage([
          '/home',
          'view-questions',
          firstCategory.sub_category,
          affiliate,
          firstCategory.category_id
        ]);
      } else {
        // No category available to open a form -> show only the dashboard part.
        this.tourService.startCombinedDashboardHomeTour();
      }
    }, () => {
      // On error, gracefully fall back to the single-page dashboard tour.
      this.tourService.startCombinedDashboardHomeTour();
    });
  }

  /** Whether the given route (ignoring query params) has a guided tour. */
  private isTourEnabledRoute(url: string): boolean {
    const path = url.split('?')[0];
    // Match the exact route or any of its child routes (e.g. /home/view-questions/...).
    return this.tourEnabledRoutes.some(
      route => path === route || path.startsWith(route + '/')
    );
  }

  /**
   * Start a tour specific to the current page
   */
  startPageTour(): void {
    const currentRoute = this.router.url;
    // const url = window.location.href.split('#')[1]
    // const lastIndex = url.split('/').length - 1;
    // const lastPart = url.split('/')[lastIndex];
    // const parts = url.split('/'),giftsValue = parts.indexOf('view-questions') !== -1 ? parts[parts.indexOf('view-questions') + 1] : null;
    switch (currentRoute) {
      case '/home':
        this.startHomeCombinedTour();
        break;
    }
  }

  /**
   * Stop current tour
   */
  stopTour(): void {
    this.tourService.stopTour();
  }
}
